import { FC } from 'react';

import { Grid, Skeleton, Theme } from '@mui/material';

import { getMapAndLocationsComponentStyles } from '../../GoogleMap.styles';
import { locationsListStyles } from '../ModernGoogleMap.styles';
import { googleMapWrapper } from '../ModernGoogleMapSection/ModernGoogleMapSection.styles';

interface ILoadingSkeleton {
	theme: Theme;
	isSmallScreen: boolean;
	fullWidth: boolean;
}

const LoadingSkeleton: FC<ILoadingSkeleton> = ({ theme, fullWidth, isSmallScreen }) => {
	return (
		<Grid
			container
			direction={isSmallScreen ? 'column' : 'row'}
			data-test-id="modern_google_maps_skeleton_grid_container"
			sx={getMapAndLocationsComponentStyles(theme, fullWidth)}
		>
			<Grid
				item
				container
				md={4}
				data-test-id="modern_google_maps_skeleton_location_cards_container"
				rowGap={3}
				sx={{ ...locationsListStyles, height: '100%' }}
			>
				<Skeleton
					variant="rounded"
					height="4rem"
					sx={{ m: '1.5rem 1.5rem 0' }}
					data-test-id="modern_google_maps_skeleton_header"
				/>
				{!isSmallScreen && (
					<>
						<Skeleton
							variant="rounded"
							height="12rem"
							sx={{ mx: '1.5rem' }}
							data-test-id="modern_google_maps_skeleton_card_1"
						/>
						<Skeleton
							variant="rounded"
							height="12rem"
							sx={{ mx: '1.5rem' }}
							data-test-id="modern_google_maps_skeleton_card_2"
						/>
						<Skeleton
							variant="rounded"
							height="12rem"
							sx={{ mx: '1.5rem' }}
							data-test-id="modern_google_maps_skeleton_card_3"
						/>
					</>
				)}
			</Grid>
			<Grid item md={8} xs={12} data-test-id="modern_google_maps_skeleton_map_section" sx={googleMapWrapper}>
				<Skeleton
					variant="rounded"
					height={isSmallScreen ? '24rem' : '100%'}
					sx={{ m: { xs: '1.5rem 1.5rem 0', md: '0' } }}
					data-test-id="modern_google_maps_skeleton_map"
				/>
				{isSmallScreen && (
					<Skeleton
						variant="rounded"
						height="4rem"
						sx={{ m: '1.5rem 1.5rem 0' }}
						data-test-id="modern_google_maps_skeleton_mobile_input"
					/>
				)}
			</Grid>
		</Grid>
	);
};

export default LoadingSkeleton;
